import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { DPI_CHARGES, } from "@frameworks/web/redux/interfaces/Reports/iDpInterest";
const DpChargesReducer = (state, action) => {
    switch (action.type) {
        case DPI_CHARGES:
            return Object.assign(Object.assign({}, state), { dpiCharges: action.payload.dpiCharges });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: DpChargesReducer,
    commonData: commonOnePlatFormReducer,
});
